import { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { NavMenuContext } from './nav-menu.context';
import { NavMenuState } from './nav-menu.model';

export interface NavMenuProviderProps {
  children: ReactNode;
  onLinkSelect?: (link: string) => void;
  selectedLink?: string;
}

export function NavMenuProvider({ children, onLinkSelect, selectedLink }: NavMenuProviderProps) {
  const [selectedOrgan, setSelectedOrgan] = useState('');
  const linkItemRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleOrganSelect = useCallback((value: string) => setSelectedOrgan(value), []);

  useEffect(() => {
    if (selectedLink) {
      setSelectedOrgan(selectedLink);
    }
  }, [selectedLink]);

  useEffect(() => {
    if (selectedOrgan) {
      const linkItem = linkItemRefs.current.find(
        (item) => item?.getAttribute('data-selected') === 'true',
      );

      if (linkItem) {
        linkItem.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }, [selectedOrgan]);

  const value: NavMenuState = useMemo(
    () => ({
      linkItemRefs,
      onLinkSelect,
      onOrganSelect: handleOrganSelect,
      selectedOrgan,
    }),
    [linkItemRefs, handleOrganSelect, onLinkSelect, selectedOrgan],
  );

  return <NavMenuContext value={value}>{children}</NavMenuContext>;
}
